<!--线索联系人所在单位下拉选择器-->
<template>
    <el-autocomplete
        size="small"
        v-model="AdressIds"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入关键词"
        @select="handleChange"
        @blur="handleBlur">
        <template slot-scope="{ item }">
            <div class="label" :title="item.value" >{{ item.value }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
import CommonService from "~/services/common";

export default {
    name: "AdressClueSelect",
    data() {
        return {
            AdressIds: null
        };
    },
    methods: {

        querySearchAsync(queryString, cb) {
            let qs = (queryString || '').toString().trim() || undefined;
            let params = {
                fields: 'id,customer_name',
                customer_name: qs
            };
            CommonService.getSaleLeads(params).then(res => {
                if (!res.data) return;

                let results = res.data.filter(item => {
                    if (!qs) return true;
                        return item.customer_name.toString().indexOf(qs)> -1;
                }).map( item => {
                    return { 
                        value: item.customer_name, 
                        label: item.id 
                    };
                });
                cb(results)
            });
        },

        //select value值变化时触发
        handleChange(item) {
            this.$emit("change", item.value);
        },

        handleBlur($event) {
            this.$emit("change", $event.target.value);
        },
        
        reset() {
            this.AdressIds = '';
        }
    }
}



</script>


// WEBPACK FOOTER //
// src/widgets/ClueAdressSelect.vue